import { PaletteOptions, SimplePaletteColorOptions } from '@mui/material/styles/createPalette'

interface DefaultPaletteOptions extends PaletteOptions {
  primary?: SimplePaletteColorOptions
}

export const paletteColors = {
  white: '#FFFFFF',
  dark: '#000000',
  lightDark: '#111827',
  primaryColor: '#081c1d',
  darkRed: '#9B1C1C',
  red: '#ec5f59',
  lightRed: '#fbd5d5',
  green: '#5aae88',
  lightGreen: '#6cc49e',
  darkGreen: '#0e2a2b',
  turquoise: '#436c6c',
  darkTurquoise: '#163939',
  greyTurquoise: '#6B7280',
  blueGreen: '#1d4747',
  lightGrey: '#E5E7EB',
  greySoft: '#F9FAFB',
  nearWhite: '#F3F4F6',
  yellow: '#fcc701',
  blueGrey: '#9fb5b6',
  iconGrey: '#cfdada',
  iconLightGrey: '#ecf4f4',
  lightBlue: '#58B0E1',
  violet: '#743BBC',
  darkGrey: '#4B5563',
  purple: '#B652BF',
  greyBlue: '#EAEAEA',
  softGrey: '#E3E3E3',
  grey: '#737272',
}

export const palette: DefaultPaletteOptions = {
  primary: {
    main: paletteColors.violet,
    light: paletteColors.iconGrey,
    dark: paletteColors.iconLightGrey,
  },
  secondary: {
    main: paletteColors.lightGrey,
    light: paletteColors.blueGrey,
  },
  info: {
    main: paletteColors.lightBlue,
    light: paletteColors.iconGrey,
    dark: paletteColors.iconLightGrey,
  },
  text: {
    primary: paletteColors.dark,
    secondary: paletteColors.white,
  },
  error: {
    main: paletteColors.red,
    light: paletteColors.lightRed,
    contrastText: paletteColors.darkRed,
  },
  success: {
    main: paletteColors.green,
    light: paletteColors.lightGreen,
  },
  background: {
    default: paletteColors.white,
    paper: paletteColors.nearWhite,
  },
  action: {
    selected: paletteColors.nearWhite,
    active: paletteColors.iconGrey,
    focus: paletteColors.greyTurquoise,
    hover: paletteColors.nearWhite,
  },
}
